export default {
  API_URL: process.env.REACT_APP_API_URL,
};

// export const PORT = process.env.PORT || 5005;
